module.exports = __webpack_public_path__ + "static/media/09-02.0b5343f6.png";